import React, { Component } from 'react'
import { Card, Dropdown } from 'react-bootstrap'
import { LifecycleSkeleton } from '../fresh/HomeSkeleton';

import BookMarksModal from '../help_system/BookMarksModal';
import ExamModal from '../help_system/ExamModal';
import ExecuteModal from '../help_system/ExecuteModal';
import GetReadyForExamModal from '../help_system/GetReadyForExamModal';
import GetReadyForExamToolModal from '../help_system/GetReadyForExamToolModal';
import MeasureModal from '../help_system/MeasureModal';
import NotesModal from '../help_system/NotesModal';
import PlanModal from '../help_system/PlanModal';
import PractiseModal from '../help_system/PractiseModal';
import PreviousPaperAnalysisModal from '../help_system/PreviousPaperAnalysisModal';
import PreviousPapersExamsModal from '../help_system/PreviousPapersExamsModal';
import ResultAndAnalysisModal from '../help_system/ResultAndAnalysisModal';
import RevisionMaterialModal from '../help_system/RevisionMaterialModal';
import ShortNotesModal from '../help_system/ShortNotesModal';
import WarmUpModal from '../help_system/WarmUpModal';

// The four stages of the life cycle: each circle opens the stage's help
// modal, each chip the help modal for one feature in that stage.
const LIFECYCLE_STEPS = [
    { key: 'plan', label: 'Plan', icon: 'fa-calendar-alt', modal: 'planModalShow', items: [
        { label: 'Previous Paper Analysis', modal: 'prevPaperAnaModalShow' },
    ] },
    { key: 'execute', label: 'Execute', icon: 'fa-play-circle', modal: 'executeModalShow', items: [
        { label: 'Practice', modal: 'practiseModalShow' },
        { label: 'Get Ready For Exam', modal: 'getReadyForExamModalShow' },
        { label: 'Custom Exams', modal: 'examModalShow' },
    ] },
    { key: 'measure', label: 'Measure', icon: 'fa-chart-bar', modal: 'measureModalShow', items: [
        { label: 'Performance & Analysis', modal: 'resultAndAnalysisModalShow' },
    ] },
    { key: 'warmup', label: 'Warm Up', icon: 'fa-trophy-alt', modal: 'warmUPModalShow', items: [
        { label: 'Short Notes', modal: 'shortNotesModalShow' },
        { label: 'Revisional Material', modal: 'revisionMaterialModalShow' },
        { label: 'Previous Paper Exams', modal: 'prevPaperExamUPModalShow' },
    ] },
];

export class PreparationLifecircle extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            planModalShow: false,
            executeModalShow: false,
            measureModalShow: false,
            warmUPModalShow: false,
            prevPaperExamUPModalShow: false,
            revisionMaterialModalShow: false,
            shortNotesModalShow: false,
            prevPaperAnaModalShow: false,
            practiseModalShow: false,
            getReadyForExamModalShow: false,
            examModalShow: false,
            resultAndAnalysisModalShow: false,
            getReadyForExamToolModalShow: false,
            notesModalShow: false,
            bookMarksModalShow: false
        };
        this.preLoader = this.preLoader.bind(this);
    }

    componentDidMount() {
        this.loaderTimer = setTimeout(this.preLoader, 1000);
    }

    componentWillUnmount() {
        clearTimeout(this.loaderTimer);
    }

    preLoader() {
        this.setState({ isLoading: false })
    }

    render() {
        return (
            this.state.isLoading ?
                <LifecycleSkeleton />
                :
                <Card as={Card.Body} className="preparation-lifecircle plc-fresh p-0">
                    <div className="plc-head">
                        <i className="fad fa-graduation-cap plc-head-icon" aria-hidden="true" />
                        <div>
                            <Card.Title className="plc-title mb-1">STUDENT PREPARATION LIFE CYCLE</Card.Title>
                            <p className="plc-sub mb-0">Plan &bull; Practice &bull; Measure &bull; Improve</p>
                        </div>
                    </div>

                    <div className="plc-steps">
                        {LIFECYCLE_STEPS.map((step) => (
                            <div key={step.key} className={`plc-step plc-step--${step.key}`}>
                                <button type="button" className="plc-step-circle" onClick={() => this.setState({ [step.modal]: true })}>
                                    <i className={`fad ${step.icon}`} aria-hidden="true" />
                                    <span>{step.label}</span>
                                </button>
                                <div className="plc-step-items">
                                    {step.items.map((item) => (
                                        <button type="button" key={item.label} className="plc-chip" onClick={() => this.setState({ [item.modal]: true })}>
                                            {item.label}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="plc-tools">
                        <Dropdown drop="up">
                            <Dropdown.Toggle className="plc-tools-btn">
                                <i className="fad fa-tools mr-2" aria-hidden="true" />Tools
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item as="button" onClick={() => this.setState({ bookMarksModalShow: true })}>Bookmark</Dropdown.Item>
                                <Dropdown.Item as="button" onClick={() => this.setState({ notesModalShow: true })}>Notes</Dropdown.Item>
                                <Dropdown.Item as="button" onClick={() => this.setState({ getReadyForExamModalShow: true })}>Get Ready For Exam</Dropdown.Item>
                                <Dropdown.Divider />
                                <Dropdown.Item as="button" onClick={() => this.setState({ getReadyForExamToolModalShow: true })}>About Tools</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>

                    <i className="fad fa-seedling plc-deco plc-deco--plant" aria-hidden="true" />
                    <i className="fad fa-books plc-deco plc-deco--books" aria-hidden="true" />
                    <i className="fad fa-trophy-alt plc-deco plc-deco--trophy" aria-hidden="true" />

                    <PlanModal show={this.state.planModalShow} onHide={() => this.setState({ planModalShow: false })} />
                    <ExecuteModal show={this.state.executeModalShow} onHide={() => this.setState({ executeModalShow: false })} />
                    <MeasureModal show={this.state.measureModalShow} onHide={() => this.setState({ measureModalShow: false })} />
                    <WarmUpModal show={this.state.warmUPModalShow} onHide={() => this.setState({ warmUPModalShow: false })} />
                    <PreviousPapersExamsModal show={this.state.prevPaperExamUPModalShow} onHide={() => this.setState({ prevPaperExamUPModalShow: false })} />
                    <RevisionMaterialModal show={this.state.revisionMaterialModalShow} onHide={() => this.setState({ revisionMaterialModalShow: false })} />
                    <ShortNotesModal show={this.state.shortNotesModalShow} onHide={() => this.setState({ shortNotesModalShow: false })} />
                    <PreviousPaperAnalysisModal show={this.state.prevPaperAnaModalShow} onHide={() => this.setState({ prevPaperAnaModalShow: false })} />
                    <PractiseModal show={this.state.practiseModalShow} onHide={() => this.setState({ practiseModalShow: false })} />
                    <GetReadyForExamModal show={this.state.getReadyForExamModalShow} onHide={() => this.setState({ getReadyForExamModalShow: false })} />
                    <ExamModal show={this.state.examModalShow} onHide={() => this.setState({ examModalShow: false })} />
                    <ResultAndAnalysisModal show={this.state.resultAndAnalysisModalShow} onHide={() => this.setState({ resultAndAnalysisModalShow: false })} />
                    <GetReadyForExamToolModal show={this.state.getReadyForExamToolModalShow} onHide={() => this.setState({ getReadyForExamToolModalShow: false })} />
                    <NotesModal show={this.state.notesModalShow} onHide={() => this.setState({ notesModalShow: false })} />
                    <BookMarksModal show={this.state.bookMarksModalShow} onHide={() => this.setState({ bookMarksModalShow: false })} />
                </Card>
        )
    }
}

export default PreparationLifecircle
